import { useEffect } from "react";

export function useScrollToElement(configs: {
  containerId?: string;
  targetElementId?: string;
  delay?: number;
  dependency?: string;
}) {
  useEffect(() => {
    const delay = configs?.delay || 100;
    let offsetTop = 0;

    const containerElement = document.getElementById(
      configs.containerId || "scroll-container"
    );

    if (!containerElement) return;

    // if (configs.targetElementId) {
    const targetElement = document.getElementById(
      configs.targetElementId || ""
    );
    // console.log(targetElement?.offsetTop);//TODO
    offsetTop = targetElement?.offsetTop || 0;
    // }

    if (containerElement && targetElement) {
      setTimeout(() => {
        containerElement.scrollTo({
          top: offsetTop + 50,
          behavior: "smooth",
        });
      }, delay);
    } else {
      setTimeout(() => {
        containerElement.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        });
      }, delay);
    }
  }, [
    configs?.delay,
    configs.targetElementId,
    configs.containerId,
    configs.dependency,
  ]);

  return null;
}
